import { useEffect, useState } from "react";
import { message } from "antd";
import { useQuery } from "../../_utils/url_query_hook";
import { despathDateOrdersGroupByClientAndDateEvent } from "../../_events/departures/find_departures.event";

export const useDspatchByClientDate = () => {

    const [ loading, setLoading ] = useState(false);
    const [ data, setData ] = useState([]);
    const query = useQuery();

    const dynamicLoad = () => {
        load();
    }

    const load = () => {
        setLoading(true);
        despathDateOrdersGroupByClientAndDateEvent(query.get('date'), query.get('client'))
        .then(json => {
            setLoading(false);
            setData(json.list);
        })
        .catch(err => {
            setLoading(false);
            message.error(err.message);
        });
    }

    useEffect(() => {
        load();
    }, []);
    
    return {
        data, loading, dynamicLoad
    };
}